// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ACCOUNT_INITIALIZE = 'ACCOUNT_INITIALIZE';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
export const TENANT_INITIALIZE = 'TENANT_INITIALIZE';
export const SET_TENANT = 'SET_TENANT';
